//
//
//
//
//
//

import API from './api'
import qs from 'qs'
import types from './store/mutation-types'
import Window from './utils/Window'

export default {
  name: 'app',
  data () {
    return {
      show: false
    }
  },
  created () {
    this.$store.commit(types.UPDATE_APP_INNERCODE, this.$route.params.innerCode)
    this.$store.commit(types.UPDATE_APP_PRODUCTCODE, this.$route.params.productCode)
    if (this.$route.params.unionCode) this.$store.commit(types.UPDATE_ORDER_UNIONCODE, this.$route.params.unionCode)
    // if (this.$route.query.unionOrderCode) this.$store.commit(types.UPDATE_ORDER_UNIONCODE, this.$route.query.unionOrderCode)

    // 获取产品配置信息
    // 获取到产品信息之前页面是隐藏的
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.$store.commit(types.UPDATE_APP_H5, true)
    }
    // let that = this
    API.getConfig(this, {h5: this.$store.state.app.h5, innerCode: this.$store.state.app.innerCode}).then(response => {
      // 获取配置信息后再显示页面
      this.show = true

      // 从服务器获取银行列表
      if (this.isWXPayProducts()) {
        this.$http.get('/api/bank/quota/getListByProductsCode?productCode=' + this.$store.state.app.productCode).then(response => {
          let banksFromServer = response.data
          if (banksFromServer.result === true && banksFromServer.data.length > 0) {
            const banks = []
            banksFromServer.data.forEach((ele) => {
              banks.push({name: ele.bankName, value: ele.bankCode})
            })
            this.$store.commit(types.UPDATE_BANKSFROMSERVER, banks)
            this.$store.commit(types.UPDATE_RAWBANKSFROMSERVER, banksFromServer.data)
          }
        })
      }

      // 百年人寿线下核保
      let underwritingCode = this.$route.query.underwritingCode
      if (underwritingCode !== undefined && underwritingCode !== '' && ['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$route.params.productCode) !== -1) {
        this.$http.get('/api/insurance/offlineUnderwriting/data/' + underwritingCode).then(response => {
          if (typeof response.data === 'string') return
          if (response.data.code === 400) return
          // 身高
          // 体重
          // 手机号
          this.$store.commit(types.UPDATE_INSUREDHEIGHT, response.data.height.trim())
          this.$store.commit(types.UPDATE_INSUREDWEIGHT, response.data.weight.trim())
          this.$store.commit(types.UPDATE_HOLDERPHONE, response.data.mobile.trim())

          // 被保人
          this.$store.commit(types.UPDATE_INSUREDNAME, response.data.insuredName.trim())
          this.$store.commit(types.UPDATE_INSUREDIDNUMBER, response.data.insuredIdNumber.trim().toUpperCase())
          if (this.$store.state.order.insuredRelation === 1) { // 本人
            // 投保人
            this.$store.commit(types.UPDATE_HOLDERNAME, response.data.insuredName.trim())
            this.$store.commit(types.UPDATE_HOLDERIDNUMBER, response.data.insuredIdNumber.trim().toUpperCase())
            this.$store.commit(types.UPDATE_HOLDEREMAIL, response.data.email)
          }

          this.$store.commit(types.UPDATE_ORDER_OFFLINECODE, response.data.offlineCode)
        })
      }

      // 微信分享接口权限配置
      let url = encodeURIComponent(window.location.href.replace(/#.+$/, '')) // 最后的 / 一定要有
      this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(response => {
        // 合伙人分享参数设置
        if (this.isDailiren) {
          this.$route.query.isShare = 'true'
          this.$route.query.isProspectus = 'true'
        }
        // 直接显示微信分享弹窗参数
        delete this.$route.query.showShare

        // 分享
        const shareData = {
          title: this.$store.state.config.wxShare.title,
          desc: this.$store.state.config.wxShare.desc,
          // link: window.location.href.replace(/activityCode=\d+&?/, '')
          link: window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + '#/' + this.$route.params.innerCode + '/' + this.$route.params.productCode + '/?' + qs.stringify(this.$route.query)
        }
        // 判断是否是绝对路径
        if (this.$store.state.config.wxShare.img.indexOf('http') === 0) {
          shareData.imgUrl = this.$store.state.config.wxShare.img
        } else {
          shareData.imgUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + this.$store.state.config.wxShare.img
        }
        // 控制app不能分享
        // 调用Webview控制不能分享
        // let u = window.navigator.userAgent
        // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
        // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        // if (that.isDailiren) {
        //   if ((that.$route.params.productCode === '151072428587363110' || that.$route.params.productCode === '151013300258317638') &&
        //     that.$route.query.haveQulification !== '11' && that.$route.query.haveQulification !== '1') { // 代理人未认证的不能分享
        //    if (isAndroid) {
        //      location.href  = 'wkbappAndroid://doAction?methodName=showShareBtn&param=0'
        //    }
        //     if (isIOS) {
        //       location.href = 'wkbappIOS://doAction?methodName=showShareBtn&param=0'
        //     }
        //   } else {
        //      if (isAndroid) {
        //       location.href = 'wkbappAndroid://doAction?methodName=showShareBtn&param=1'
        //      }
        //     if (isIOS) {
        //       location.href = 'wkbappIOS://doAction?methodName=showShareBtn&param=1'
        //     }
        //    }
        //  }
        this.$wechat.ready(() => {
          // 需要代理人信息
          const agentCode = this.$route.query.agentCode
          let needAgentCode = false
          const supAgentCode = this.$route.query.supAgentCode
          if (Window.isWX() && this.h5 && (agentCode === undefined || agentCode === null || agentCode === '') && supAgentCode === 'true') {
            needAgentCode = true
          }
          if ((this.$store.state.app.productCode === '151072428587363110' || this.$store.state.app.productCode === '151013300258317638') &&
            this.$route.query.haveQulification !== '1' && this.isDailiren) {
            this.$wechat.hideOptionMenu()
            console.log('禁止分享')
            return
          }
          // 隐藏微信分享
          if (this.$store.state.config.wxShare.hide || needAgentCode) {
            this.$wechat.hideMenuItems({
              menuList: [
                'menuItem:share:appMessage',
                'menuItem:share:timeline',
                'menuItem:share:qq',
                'menuItem:share:weiboApp',
                'menuItem:share:facebook',
                'menuItem:share:QZone'
              ]
            })
          }
          // 分享给朋友
          this.$wechat.onMenuShareAppMessage({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.imgUrl // 分享图标
          })
          // 分享到朋友圈
          this.$wechat.onMenuShareTimeline({
            title: shareData.title, // 分享标题
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.imgUrl // 分享图标
          })
          // 分享到QQ
          this.$wechat.onMenuShareQQ({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接
            imgUrl: shareData.imgUrl // 分享图标
          })
          // 分享到腾讯微博
          this.$wechat.onMenuShareWeibo({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接
            imgUrl: shareData.imgUrl // 分享图标
          })
        })
        this.$wechat.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: response.data.appId, // 必填，公众号的唯一标识
          timestamp: response.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
          signature: response.data.signature, // 必填，签名，见附录1
          jsApiList: [
            'hideMenuItems',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareQZone'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
    })
  },
  computed: {
    h5 () {
      return this.$store.state.app.h5
    },
    isDailiren () {
      // 是合伙人
      // 不是悟空保，且不是H5
      // 是否是悟空保的innerCode
      const isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1
      if (!this.h5 && !isWKB) {
        return true
      }
      return false
    }
  },
  methods: {
    isWXPayProducts () {
      return ['150476691002746473', '150537492578996275', '150831059068987214', '150840325766681140', '151013300258317638', '151072428587363110', '150634119420883220', '150631164164706555'].indexOf(this.$store.state.app.productCode) !== -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue